import React from "react";
import {
  Smartphone,
  Flame,
  Apple,
  Database,
  Server,
  Cloud,
  Code2,
  Braces,
  BrainCircuit,
} from "lucide-react";

const techStack = [
  { name: "React Native", icon: Smartphone, color: "text-cyan-600" },
  { name: "Flutter", icon: Smartphone, color: "text-sky-600" },
  { name: "Swift", icon: Apple, color: "text-orange-600" },
  { name: "Kotlin", icon: Database, color: "text-blue-600" },
  { name: "Node.js", icon: Server, color: "text-emerald-600" },
  { name: "Firebase", icon: Flame, color: "text-amber-600" },
  { name: "AWS", icon: Cloud, color: "text-gray-600" },
  { name: "GraphQL", icon: Code2, color: "text-pink-600" },
  { name: "TypeScript", icon: Braces, color: "text-blue-600" },
  { name: "TensorFlow", icon: BrainCircuit, color: "text-purple-600" },
];

export default function TechStackk() {
  return (
    <section className="bg-[#F8F8FB] py-20 px-6 border-t border-gray-200/60">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="flex justify-center mb-4">
            <span className="text-sm md:text-base font-semibold tracking-[0.32em] uppercase font-mono text-[#355dff]">
              Powered By
            </span>
          </div>
          <h2 className="font-extrabold text-[#111827] text-4xl md:text-5xl">
            Our Mobile Tech Stack
          </h2>
        </div>

        {/* Tech Pills */}
        <div className="flex flex-wrap justify-center gap-4">
          {techStack.map((tech, index) => {
            const Icon = tech.icon;
            return (
              <div
                key={index}
                className="group flex items-center gap-3 px-6 py-3.5 rounded-full border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#355dff]/40 hover:shadow-md cursor-pointer"
              >
                <Icon
                  size={18}
                  className={`${tech.color} transition-transform duration-300 group-hover:scale-125`}
                />
                <span className="text-gray-700 text-sm font-medium group-hover:text-[#355dff] transition">
                  {tech.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}